import * as React from "react";
import type { SVGProps } from "react";
const SvgInformationCircleFill = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#information-circle-fill_svg__a)">
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-.71 5.29a1.03 1.03 0 0 1 1.42 0q.135.15.21.33c.06.12.08.25.08.38s-.02.26-.08.38c-.05.13-.12.23-.21.33q-.135.135-.33.21c-.12.05-.25.08-.38.08s-.26-.03-.38-.08c-.13-.05-.23-.12-.33-.21-.18-.19-.29-.45-.29-.71s.11-.52.29-.71M14 17h-4c-.55 0-1-.45-1-1s.45-1 1-1h1v-3h-1c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1v4h1c.55 0 1 .45 1 1s-.45 1-1 1"
      />
    </g>
    <defs>
      <clipPath id="information-circle-fill_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInformationCircleFill;
